var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _rect3, _path6, _rect4, _path7, _rect5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _polygon2, _path16, _rect6, _polygon3, _polygon4, _polygon5, _path17, _ellipse, _circle, _circle2, _circle3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _polygon6, _polygon7, _polygon8, _circle4, _circle5, _circle6, _polygon9, _polygon10, _polygon11, _circle7, _circle8, _circle9, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _path18, _path19, _path20, _path21, _path22, _path23, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path24, _polygon12, _path25, _path26, _path27, _path28, _path29, _path30, _polygon13, _path31, _path32, _path33, _path34, _circle10, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebdev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.89,126.73S546.42,174.26,630,195.38c0,0,148.75,40.13,169.87,111.44,0,0,32.19,63.55,8.54,142.86-13.73,46.08-43.52,85.69-83.32,112.66-56.24,38.09-174.94,97.38-354.58,82.34-2.74-.23-5.5-.36-8.25-.39-22.15-.23-142-5.7-238.19-95C77.86,506.38,51.17,446.45,49,383.39c-3.12-90.53,11.38-234.8,122.45-305.95C171.46,77.44,335.18-44.91,498.89,126.73Z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.89,126.73S546.42,174.26,630,195.38c0,0,148.75,40.13,169.87,111.44,0,0,32.19,63.55,8.54,142.86-13.73,46.08-43.52,85.69-83.32,112.66-56.24,38.09-174.94,97.38-354.58,82.34-2.74-.23-5.5-.36-8.25-.39-22.15-.23-142-5.7-238.19-95C77.86,506.38,51.17,446.45,49,383.39c-3.12-90.53,11.38-234.8,122.45-305.95C171.46,77.44,335.18-44.91,498.89,126.73Z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M519.49,408c0-63.06,52.2-114.18,116.6-114.18A117.93,117.93,0,0,1,697.67,311c33,20.16,55,56.05,55,97,0,63.06-52.21,114.18-116.6,114.18a118,118,0,0,1-57.47-14.81h0C543.31,487.74,519.49,450.59,519.49,408Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M636.09,277.9c-73.37,0-132.85,58.24-132.85,130.09s59.48,130.09,132.85,130.09S768.93,479.84,768.93,408,709.45,277.9,636.09,277.9ZM519.49,408c0-63.06,52.2-114.18,116.6-114.18A117.93,117.93,0,0,1,697.67,311c33,20.16,55,56.05,55,97,0,63.06-52.21,114.18-116.6,114.18a118,118,0,0,1-57.47-14.81h0C543.31,487.74,519.49,450.59,519.49,408Z",
    fill: "#243E59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 632.61,
    y: 305.46,
    width: 8.7,
    height: 20.3,
    rx: 3.66,
    fill: "#243E59"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M752.69,408c0,63.06-52.21,114.18-116.6,114.18a118,118,0,0,1-57.47-14.81c103.8,31.92,146.8-52.24,146.8-52.24C769.51,371.59,697.66,311,697.66,311h0C730.7,331.17,752.69,367.06,752.69,408Z",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 719.62,
    y: 395.95,
    width: 8.7,
    height: 20.3,
    rx: 3.66,
    transform: "translate(1130.08 -317.87) rotate(90)",
    fill: "#243E59"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 636.67,
    y: 487.61,
    width: 8.7,
    height: 20.3,
    rx: 3.66,
    transform: "translate(1282.04 995.52) rotate(-180)",
    fill: "#243E59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M690,454c-17.73-14.5-34.92-29.63-52-44.9l-1-.92c4.36-5.26,8.83-10.44,13.24-15.66,12.33-14.37,25.12-29.08,38-42.94-11.48,15.07-23.82,30.15-35.9,44.74-4.09,4.87-8.15,9.79-12.28,14.63l-.14-2c17,15.38,33.79,30.92,50.06,47Z",
    fill: "#243E59"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122.7,
    y: 132.59,
    width: 493.67,
    height: 306.87,
    fill: "#ebebeb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M617.23,440.33H121.83V131.72h495.4Zm-493.66-1.74H615.49V133.46H123.57Z",
    fill: "#EC1C24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.7,
    y: 132.59,
    width: 493.67,
    height: 21.46,
    fill: "#EC1C24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402.29,621h0a22.85,22.85,0,0,1-17.79-27.15l34.26-164.95A23.2,23.2,0,0,1,446,410.85h0A22.86,22.86,0,0,1,463.73,438L429.47,603A23.17,23.17,0,0,1,402.29,621Z",
    fill: "#EC1C24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M424.46,461.05s-6.65,106.54-36.15,151c0,0,10.22,16.08,30.38,6.18Z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M500.07,374.21a35.82,35.82,0,0,1-2.73,11.63s-2.75,14.2,9.84,14c0,0,8.54.42,13.47,2.45,0,0-6-26.45-9.51-35.7H502.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M500.07,374.21a35.82,35.82,0,0,1-2.73,11.63s-2.75,14.2,9.84,14c0,0,8.54.42,13.47,2.45,0,0-6-26.45-9.51-35.7H502.3Z",
    fill: "#332113"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M451.8,402.73s-24.23,3.83-26.42,18.54L418.2,632.59H608.78L561.5,436.27A35.29,35.29,0,0,0,546,414.66c-10.63-6.69-26.21-14.86-38.82-14.78Z",
    fill: "#EC1C24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M418.2,632.59H608.78l-66.2-160.72s-2.21,16.32,7.07,51.12c0,0,6.38,42.35-1.74,40.61l-68.86-9.12s-8.28-5.25-58.75,19.92Z",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M460.3,431.21c6.81,6.42,17.74,2.8,25.15-.78,6.32-3,12.08-7.14,17.79-11.15a103.81,103.81,0,0,1-9.53,7.41c-8.31,5.81-25.11,13.84-33.41,4.52Z",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M475.12,561.57s-42.76-.45-56.92,6.88l-16.75,16.36,16.75,25.41,12.39-20.34a8.32,8.32,0,0,1,7-4c6.07-.08,16.71-.45,22.71-2a26.3,26.3,0,0,1,8.92-1.36S466.71,570.57,475.12,561.57Z",
    fill: "#f2c5be"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "406.38 592.29 415.07 583.33 408.45 595.43 406.38 592.29",
    fill: "#f29596"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.73 598.88 422.03 587.39 413.51 603.11 410.73 598.88",
    fill: "#f29596"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M435.33,586.23s2.36-2.32,17.44-4.64c0,0,10.9,1.16,17.92-13.05,0,0-3.58,7.92-1.47,14,0,0,2.08-.42-8.92,1.36A97.11,97.11,0,0,1,435.33,586.23Z",
    fill: "#f29596"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 210.29,
    y: 632.05,
    width: 487.28,
    height: 15.66,
    fill: "#4f311c"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 496.89 271.15 632.59 427.01 632.59 335.26 496.89 181.87 496.89",
    fill: "#243E59"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.26 496.89 345.12 496.89 435.32 632.59 427.01 632.59 335.26 496.89",
    fill: "#243E59"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "335.26 496.89 345.12 496.89 435.32 632.59 427.01 632.59 335.26 496.89",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M540.52,632.05V619.17L427,620.09l8.32,12.5S540.52,631,540.52,632.05Z",
    fill: "#243E59"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.99,
    cy: 563.89,
    rx: 18.56,
    ry: 7.83,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 151.7,
    cy: 143.61,
    r: 4.06,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.46,
    cy: 143.61,
    r: 4.06,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.1,
    cy: 143.61,
    r: 4.06,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("image", {
    width: 510,
    height: 341,
    transform: "translate(136.05 164.97) scale(0.24)",
    opacity: 0.2,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAf4AAAFVCAYAAAAOtI0IAAAACXBIWXMAAC4jAAAuIwF4pT92AAATQUlEQVR4Xu3d0XYaObOAUREnM+f93/afxOFcOErKZUktMLZxau+1enXTxkBz80kCJ6fz+dwAgBq+HN0BAPh7CD8AFPL16A7v4XQ6nY7uAwCf3fkOPl8/vddrEHcAmHuvQcGbhf+VoX/N7wLAvbg6sm81ELhp+Ddjv3MfAKjiMMS3HATcJPwHwZ/9zAAAgMpmAZ6G+RYDgFeFfxH8fP7o9u7PAOCzWYU2/+zo9tPJV8T76vBPoh/P7RyPbs/OAcBnM4rsKu47x08nrgz4VeEfRH8U9tW5SwcCAPBZ7YQ+74/OPd24IuIXhf9glr+zP7pPJ/4A/A1m0R/tVz8b7X+7ZADwmn/AZzajz8dHt/PvRwYAAHxGO8HPx6Ofdef21MS+7+cuth3+NNs/mtXvbG1x3G8DwGeVl+iPoj/bRuJAoJ1Op9PurH9rqX8j+kfbl437jB43MxgA4B6NYjqb5a+2nxv3GT3u08FG1A9n/Buf669Cf7S/JP6iD8A9i9Hdjf7PtD8Nzo/E+/62M/M/DH+SQ7wKftzyuZ1BQAv7TvwBuEc5tqvg59j/DNuXX/tT+xP92QCgP8eLAcDKMvyLJf7d4PftYfEz8QfgM7s2+qPtsb1s4c4A4Hf8j2b9t5zxj0If9/ncbBAwC7/gA3DPzoN9jv4s9jH68TjqKwHdbWf8k9l+P94J/tE2GgScwn426zcAAOCexOiOoj+a5cfY9623sEf/8ddjjQYA8fyLAcBq1n/JjD8HfxX/h/b02Kv9bACQ498GewC4J7PZfo7+KPg/wj73r4uPO2vi1qx/J/yj2K6C3+N+tI1WAI6W/Vsbvx4A+Ch5xr9a3n9sL6P/0P5E/0cbh7/rz9WX/XPsR+eeGYZ/8m/x7872Y9y//dq+DvZ5BSDO/POsfza6MQgA4CPkuB4t8ceZfpzh/2itfW8vV76zPKAYTYz7/VprbbrcvzPjz1bRjzP+b2n7pz2Pfz9exX806xd7AO7JKPox/rPof29/ov+9zUM+2/r9lzP87Cj8OzP/2Yw/Bv+f9jz+cRAwWvpfLfcLPwD3ZBb+0fL+j7D19sXox8blx/oSjnMfY/yXg4Gj8Lc2fjEx+Kf28vP6GP9/wvZvezkYGMV/9ll/a89fR2cwAMB7GAV1FP7R5/ox+nF5/6E979zoMeLHBn0AkGPfLVcAXoR/8k/0/v7xYMtL/Tn6ff/vr+2fsI9L/jH+8Y2I8W9hHwk/AO9hJ/w90nmJP0Y/9u5LeqxZ+Hv0j2b8v40+59+Z8Xer6B/F/9/BFlcC+n37764+629hDwAfabXM38PfP9f//uv4v/aycfHx+qChbw/t+d/5XxT/bBX++ELy8e6MP3/W/29r7f/ay/jnL/vFJf/+HC08Z2cAAMBHiJGNy+75m/xxmT9+mS82rj9G/J1v6fdj/EcT4taex386ENiZ8cdZdj6OYV7N+POsP8c/fvs/h391kW1wGwDeUg7qaLafw9+X9+MSf4z+6Pe+tj9/5x97OPoIvId+GvzuKPyjqI7iP1vuz9/sjwOAHv/VrP8o/KIPwEcYzfhnAe/f4J9Ff/YlwNzC3MTWxh1cxv8o/FkOcI7/Q9rizH82+4/xH33J75ILBYC3Mopp/ow/f5s//+neank/f/FvZwU8T4gP7YZ/NNOO0Y/x7wOAr+1l/P9J2+iz/hj++CblC7zoQgHgxnL0Y/zz7D3/Az1H0Z9NgHMTu357uczfWgr/wZ/ytfYyvDH+o1n/18E2W/6Py/39d0czfuEH4B6Mwh9n/H2m/73NZ/ox+HnVe7TUP2rhsof5T/p2Z/xZnoHn+OdBQI7+KP6XfM7fiT8AH2H2GX9c5n9oL//TnX6/uBowW+3O26i9F7sm/LNZfx4APIR9XvqPgc8Dgd3wX3XBAHAjqxl/X8KfzfS/tef/gl/u3tHn+i0db9sJ/yy0o/h/Cfu87J8vbLT8HwcD14T/4jcAADbsfLEvhr+3K963z/Tz7D4v7ef27TQwnl9+zj8L/+oB8/m85RebtzwQ+JqOVzP+/iau4g8Ab+2c9vEf7on/ql7XZ/pHn+GPGjpqbTSL/nAQsDPjH8lPPBsAxBeeRzOzlYB8bnbhkQEAAO8hh7TP5L+0l+Fv4VzvWvz7/Etm+bPuXuya8K+eePQiR4OAvAKwGhgIPwD3Yhb+vsVGxeX/2LrVDH/W0W50+yLXhH9kZwDwJR1fs/XnyHsAeE95qb8HPv78qGm5i5cE/2q3Cn83G6msBgC7A4F+v/48cQ8A72n0GX9vVD+/atlR8GcDgFd7bfjzaGT089GLP7rAuI3eqBb20U3fHAD4JS/xn9qfpf0e+R7/uOR/tLXBuaO+vap1rwn/LMBHYd7Z8ghoNCLKXvVGAMDCqc3j3/X4r9o127JT2h+d3/aa8Ef5hcR9vrDV7dH5bvRzAHgvuTt9Zh9v9/vtNu6ol6P9q9wq/Lvyi55dxOqNGu0B4D3FZf64H7Ur223hm4hfRPgooxHP7H6jPQC8t90m7Tbu3bzljH834Pn86PhodPThbyQAJaz+Zbzcq9lxvH3Uypv7qBn/LS/olo8FACu3bM4tH2vbe4X/muWNnd85+jkA3NpRe3b6lV3zO1d5r/DPXHqRl94fAN7apW269P439dHhH3n3zzsA4JU+TbvuMfwAwBsRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKET4AaAQ4QeAQoQfAAoRfgAoRPgBoBDhB4BChB8AChF+AChE+AGgEOEHgEKEHwAKEX4AKOQew3++8DwAfLRP066PDv+lb8il9weAt3Zpmy69/029V/jP7fIL3fmdo58DwK0dtWenX9k1v3OV9wp/dsuLu+VjAcDKLZtzy8fa9vXoDq9w9HlH/nm8nY/PrbVTOpdvA8B7GnVs1bJ839H5/POb+6gZfxTfqNVSR36T3uxNAYADu03abdy7ecsZ/8hqlp/P5+002QPARxjFP28juy18E7cK/2zkM3oDVrdH57t4PIp+XPoHgFsbBXoU+Usad9TL0f5VXhP+2QtZvcDRGzDafranjyHy7fg4OfSjcwBwC7Om9X1vVW7ZUe/6lp3T/uj8tteEv7XnTzx74aOLO3oD8hv3pT0fDMTl/ujqNwIALpAD3CN/SexXTcziuVe17rXhz44uML8p8Y0abTHsPf4tnDfDB+AjnAf7WcviNuvg0XYztwp/fmE7wd/ZRn/C17fIAACA95AjPGrdJdvRACA/z6tdE/7VCxm96HhBo4t+DPvH9jSzj3Hvj3Fqwg/Ax9oN/+Ngi80bDQBm8T/q7kWuCX9re8HPsR+9CX370Vp7aM/D3x/3SzjXv+BnqR+Aj3RO+53m/ZicjwODo0FAl29vm4X/3Mb/Ml5+klnwj2b48U340Z5ex4/28pv7Ofxxtj+KvoEAAG9hFNnYxtzA3rnv7U/rHtNxDv5oBeBoANDC7dn5Z3Zm/H0QsHqieMGjCx+Ndn6E7Xt7uYTfH+OS8APAe9kJf29c32L7VisBq9l/C/tudv6FnfBn+YnzFi86X3x8E77+2r63l8v7P9vT0v9Dm4e/NfEH4GPEwF4S/u/pXGxjjH6Of95aOt52TfhbWwc/bnl23y+0R/+hjb/I9/jr51+aGT8A92k0CY4N7DHv7fsvbKPBQI5/3mYDgIs8C//5fD6fTqdVUEcjjXyheWk/bz38fTafZ/o9+j/SfYQfgHsy6mFsWZ74/tfG8R+1crTsP1vyXw4Azufzs5/vzvjzA+cLHMU/Ll/Ei45L+LOZfhwY5Bl/a+PoGwgA8JZGgc0BHrWwbz34/2vjQUCMft/n6I/i3wa3p3bD3+VRTb7Qx7SNZvmrmf63wf1mM/7WxB6AjzGbDI+aGD/qjvGPA4DZkn+e9c86vO0o/Of2Mq6r0c3oQmch74+RR0UPbT/8bXAbAN5SDu1R+B/b88/zY/jz7D9/6S/P+mP8W3v5WmbnfjsKf2t/4p+fqF/cbHTTwz8KeH+MHP1+/7wyEP/hHjN+AD7aaMbf2vMu5hXw2ax/NPvPM//Zcn8bHC+twh9n+/l4NbLps/bvaT+b6feR0Ldf9+vf5vfFPgDuXY5vbGMPdg94D3qc4cfox9n+Ufzj1s2On9mZ8Xf5iWL0V/HPs/T8pvxof77QF7/U1//Uzxf7ALgXo6Dm+Pc491jHle088/9fGw8AZtGfxX8a+uxF+A/+pG8V/8f2FOkfbf2P7sT7x+8BjL4LsPv3+8IPwHvYCX+eGOePwXv74tJ+jP5R/Lejn/+Ur7W9GX/8pbxU32fkj+E4xj8Gu7+4OAIaRf/oS30iD8A9GYU/T4xX8R/tc/T7Fh839vlwENAdhf/cxsv0+cJO7c/FjWb58f7x4nvw8xL/KPrCD8A9moW/NzIv+ccV7/iZfvycP8f/kmX+ZfyPwj8yiv6pzaMff+exPX2JL34PYBb9nWV+gwAAPsIstrmRR/GPX+SL+34cZ/uz+F9kGP7B5/yjC5zFP+v3icsdeWk/f66/+tt9sQfgnsRGjmb8o8/7R0v/s21nxv9iEDD6fL+1vRn/uc1n8D9/3Z7FOF94vNAY/Py5/uyb/KIPwD06D/Z51p9n/rGJq/1qxp8drgDshL8bzfr7fjYAyOF/aE8vfhT83SV+8QfgnuQZf9/P4j8bAMy2i2f7K9Pwp+X+OOvPo5oe/W402okXOlrW3/kWv+ADcM9ms/5RD1eDgHwu338W/N/Hs2X+1i6b8bc2HgD049EA4Nyegt5/3v/072iWP5vtj24DwEfKkZ2Fv7dwZxAw2g6Dv2MZ/smsf/QEP9vzAcHoQmexF30APrtr458HAaNBQbzvaGthv5ztt3a7GX83GgD06Pf9Kvar5X3RB+CejWbhqwHAbBAw2s+C3x9722H4J/+Ebx8AzJ6sDwDOad/PXxr9TvwBuEejHu7GfzQQONri4/52NNtvrbXTxn1aa62l+M8ivYr6LPKj434bAD6rPCvPA4B4vLO1xX4r+q1dEP7WpvGPx6OQH93Ovx+JPwCfUY7rKNij+K9ux99/drwb/dY2lvoX+pOcfh2f2vMX1O+zE3rBB+BvtDMA6PujWf0o/he7aMbfDT7zn83+Z+dmKwej2wDwmc3iH49XM/rhLL+1y2b63VXhb20Y/9bmQb809OIPwN9gFNmdgcDq+OnElQG/OvytTePf2nHcV2EXfQD+JqvQrgYBo9tPJ18R71eFv1sMAFqbh1zgAahsFuBpmF8T/O4m4e8OBgDdzn0AoIrDEN8i+N1Nwx9tDgJmXvO7AHAvro7sLWMfvVn4s1cOBADgr/ZWoc/eLfwrBgUAVPBecV+5i/ADAO/jy9EdAIC/h/ADQCH/D81jBl5Vxh9GAAAAAElFTkSuQmCC",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140.1,
    y: 169.13,
    width: 110.22,
    height: 69.61,
    fill: "#EC1C24"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 152.86,
    y: 180.74,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 155.76,
    y: 191.18,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 178.97,
    y: 180.74,
    width: 58.59,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 201.62,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 154.02,
    y: 212.06,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 174.33,
    y: 201.62,
    width: 63.23,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148.8,
    y: 222.5,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 174.91,
    y: 222.5,
    width: 63.23,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 184.19,
    y: 212.06,
    width: 53.37,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 183.61,
    y: 191.18,
    width: 53.95,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 140.1,
    y: 247.45,
    width: 110.22,
    height: 174.61,
    fill: "#EC1C24"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 148.8,
    y: 259.05,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 154.02,
    y: 269.49,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 174.91,
    y: 259.05,
    width: 62.65,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 279.93,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 148.22,
    y: 290.37,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 174.33,
    y: 279.93,
    width: 63.23,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 148.8,
    y: 300.82,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 154.02,
    y: 311.26,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 152.86,
    y: 342,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 185.93,
    y: 300.82,
    width: 51.63,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 321.7,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 332.14,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 351.87,
    width: 21.46,
    height: 5.8,
    rx: 2.44,
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 180.13,
    y: 321.7,
    width: 57.43,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 351.86,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 362.31,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 372.75,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 383.19,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 393.63,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 177.23,
    y: 404.07,
    width: 59.75,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 180.13,
    y: 310.1,
    width: 57.43,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 187.09,
    y: 290.37,
    width: 50.47,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 199.85,
    y: 342,
    width: 37.13,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 186.51,
    y: 332.14,
    width: 50.47,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 187.09,
    y: 269.49,
    width: 50.47,
    height: 5.8,
    rx: 2.44,
    fill: "#fff",
    opacity: 0.3
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 80.93,
    y: 359.99,
    width: 106.74,
    height: 49.89,
    fill: "#243E59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.69 382.9 93.69 387.54 111.68 394.5 111.68 389.68 100.45 385.8 111.68 381.16 111.68 375.36 93.69 382.9",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "146.48 383.48 146.48 388.12 128.5 395.08 128.5 390.26 139.72 386.38 128.5 381.74 128.5 375.94 146.48 383.48",
    fill: "#fff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.68 402.04 117.06 402.04 129.35 367.82 123.28 367.82 111.68 402.04",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.15,
    cy: 394.79,
    r: 3.19,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.43,
    cy: 394.79,
    r: 3.19,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.72,
    cy: 394.21,
    r: 3.19,
    fill: "#fff"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.66 175.51 263.66 180.16 281.64 187.12 281.64 182.29 270.42 178.41 281.64 173.77 281.64 167.97 263.66 175.51",
    fill: "#EC1C24"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.45 176.09 316.45 180.74 298.47 187.7 298.47 182.87 309.69 179 298.47 174.35 298.47 168.55 316.45 176.09",
    fill: "#EC1C24"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "281.64 194.66 287.03 194.66 299.32 160.43 293.25 160.43 281.64 194.66",
    fill: "#EC1C24"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.12,
    cy: 187.41,
    r: 3.19,
    fill: "#EC1C24"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.4,
    cy: 187.41,
    r: 3.19,
    fill: "#EC1C24"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.69,
    cy: 186.83,
    r: 3.19,
    fill: "#EC1C24"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 201.62,
    width: 234.94,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 216.12,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 430.15,
    y: 216.12,
    width: 48.73,
    height: 5.8,
    rx: 2.44,
    fill: "#EC1C24",
    opacity: 0.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 301.37,
    y: 216.12,
    width: 120.66,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 228.3,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 300.79,
    y: 228.3,
    width: 129.36,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 300.79,
    y: 253.25,
    width: 114.28,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 301.37,
    y: 302.56,
    width: 107.9,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 300.21,
    y: 278.19,
    width: 127.62,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 422.03,
    y: 253.83,
    width: 168.81,
    height: 5.8,
    rx: 2.44,
    fill: "#EC1C24"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 241.07,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 253.25,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 265.43,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 278.19,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 290.37,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 302.56,
    width: 30.17,
    height: 5.8,
    rx: 2.44,
    fill: "#5fb07f"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 300.79,
    y: 241.07,
    width: 167.65,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 301.37,
    y: 265.43,
    width: 196.07,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 300.21,
    y: 290.37,
    width: 292.37,
    height: 5.8,
    rx: 2.44,
    fill: "#243E59"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 261.34,
    y: 317.06,
    width: 110.22,
    height: 105,
    fill: "none",
    stroke: "#5fb07f",
    strokeMiterlimit: 10
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 381.42,
    y: 317.06,
    width: 161.27,
    height: 5.8,
    fill: "#EC1C24",
    opacity: 0.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 503.24,
    y: 201.62,
    width: 89.34,
    height: 42.35,
    fill: "none",
    stroke: "#5fb07f",
    strokeMiterlimit: 10
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 685.95,
    y: 202.43,
    width: 63.23,
    height: 52.21,
    fill: "#243E59"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M707.72,228.38a2.87,2.87,0,0,0,1.7-.61,1.76,1.76,0,0,0,.57-1.38,27.11,27.11,0,0,0-.21-2.83c-.16-1.46-.24-2.53-.24-3.2a3.74,3.74,0,0,1,1.09-2.85,4.1,4.1,0,0,1,2.89-1h1.61v2.76h-1c-1,0-1.45.46-1.45,1.38,0,.43.06,1.31.19,2.62q0,.23.12,1.32c.06.72.09,1.37.09,1.93a3.36,3.36,0,0,1-.61,2.06,2.87,2.87,0,0,1-1.85,1.05v0a2.92,2.92,0,0,1,1.85,1.06,3.33,3.33,0,0,1,.61,2.07c0,.53,0,1.16-.09,1.88s-.11,1.18-.12,1.37c-.13,1.31-.19,2.18-.19,2.6a1.4,1.4,0,0,0,.35,1,1.57,1.57,0,0,0,1.1.33h1v2.78h-1.61a4.06,4.06,0,0,1-2.89-1,3.71,3.71,0,0,1-1.09-2.84c0-.69.08-1.76.24-3.23a26.84,26.84,0,0,0,.21-2.8,1.76,1.76,0,0,0-.57-1.38,2.8,2.8,0,0,0-1.7-.61Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M730.21,231.54a1.76,1.76,0,0,0-.57,1.38,26.84,26.84,0,0,0,.21,2.8c.15,1.47.23,2.54.23,3.23a3.68,3.68,0,0,1-1.09,2.84,4,4,0,0,1-2.89,1h-1.61V240h1a1.56,1.56,0,0,0,1.1-.33,1.36,1.36,0,0,0,.35-1c0-.42-.06-1.29-.18-2.6,0-.19-.06-.64-.12-1.37s-.1-1.35-.1-1.88a3.39,3.39,0,0,1,.61-2.07,3,3,0,0,1,1.85-1.06v0a2.9,2.9,0,0,1-1.85-1.05,3.42,3.42,0,0,1-.61-2.06c0-.56,0-1.21.1-1.93s.1-1.17.12-1.32c.12-1.31.18-2.19.18-2.62,0-.92-.48-1.38-1.45-1.38h-1V216.5h1.61a4.09,4.09,0,0,1,2.89,1,3.7,3.7,0,0,1,1.09,2.85c0,.67-.08,1.74-.23,3.2a27.11,27.11,0,0,0-.21,2.83,1.76,1.76,0,0,0,.57,1.38,2.84,2.84,0,0,0,1.69.61v2.55A2.77,2.77,0,0,0,730.21,231.54Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M497.34,385.84s-3,13.91,9.84,14c0,0,8.83,7.67-23.66,24.5,0,0-23.2,13.92-26.68-4.64a37.56,37.56,0,0,1,0-15S483.9,413.44,497.34,385.84Z",
    fill: "#f2c5be"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M456.84,404.7s-4.88,25.64,10.9,24.69c0,0,5.34.79,15.78-5,0,0,30.5-14.77,23.66-24.5a19.38,19.38,0,0,1-2.51-.23s1.47,6.16-9,13.13c0,0-23.2,19.14-30.74,14.5,0,0-5.8-2.32-7-16.24,0,0,12.58,11.59,39.36-18.57a18.56,18.56,0,0,1,0-6.63S486.42,412.29,456.84,404.7Z",
    fill: "#f29596"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M478.64,403.85a33.62,33.62,0,0,1-43.49-19.2l-7.66-19.78-.76-2a33.61,33.61,0,1,1,62.68-24.28L496.14,356l1.7,4.39A33.62,33.62,0,0,1,478.64,403.85Z",
    fill: "#f2c5be"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M496.14,356l-14.49,5.61a26.55,26.55,0,0,1-12.59,1.74c-16.69-1.87-20.93-19-20.93-19-6.38-16.82-11.6-13.34-11.6-13.34-9.28,4.06-6.11,14.43-6.11,14.43,2,16.16-2.93,19.46-2.93,19.46l-.76-2a33.61,33.61,0,1,1,62.68-24.28Z",
    fill: "#f29596"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.27,
    cy: 371.3,
    rx: 2.32,
    ry: 4.35,
    transform: "translate(-126.93 268.88) rotate(-30)",
    fill: "#332113"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 467.86,
    cy: 366.08,
    rx: 2.32,
    ry: 4.35,
    transform: "translate(-64.99 103.45) rotate(-11.8)",
    fill: "#332113"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 468.44,
    cy: 377.39,
    rx: 10.44,
    ry: 9.28,
    fill: "#ebebeb",
    opacity: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.14,
    cy: 382.03,
    rx: 11.31,
    ry: 9.28,
    fill: "#ebebeb",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M439.14,391.6c-6.39,0-11.6-4.29-11.6-9.57s5.21-9.57,11.6-9.57,11.6,4.29,11.6,9.57S445.54,391.6,439.14,391.6Zm0-18.56c-6.07,0-11,4-11,9s4.95,9,11,9,11-4,11-9S445.22,373,439.14,373Z",
    fill: "#243E59"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "477.58 372.73 477.13 372.31 495.53 357.96 495.99 358.38 477.58 372.73",
    fill: "#243E59"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M430.41,331.66c0,.06-.1.11-.14.18-2.73,4.07-3.77,8.49-2.3,12.92,4.29,13-2.59,19.34-2.59,19.34-1.87-8.65-6.25-24.42-6.25-24.42-4.06-17.4,7.25-24.65,7.25-24.65S423.71,324.22,430.41,331.66Z",
    fill: "#332113"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M430.41,331.66c0,.06-.1.11-.14.18-2.73,4.07-3.77,8.49-2.3,12.92,4.29,13-2.59,19.34-2.59,19.34-1.87-8.65-6.25-24.42-6.25-24.42-4.06-17.4,7.25-24.65,7.25-24.65S423.71,324.22,430.41,331.66Z",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M531.09,407a48.19,48.19,0,0,0-10.44-4.64s-6.25-27.32-9.51-35.7l-15-10.65s-32.4,13.73-42.62-6.55a22,22,0,0,1-1-2.34c-1.75-4.57-11.84-29-22.09-15.42h0a19.06,19.06,0,0,1-3.39-5.09h0a16.46,16.46,0,0,1,.5-15.24,20.3,20.3,0,0,1,5.12-6.06c8.27-6.67,37.92-27.87,60.17-9.08A59.88,59.88,0,0,1,510.21,324s1.74,8.7,11,15.66a7.87,7.87,0,0,1,1.1.27c2.63.82,8.13,3.86-4,13.66C518.33,353.61,524.71,367.53,531.09,407Z",
    fill: "#332113"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M531.09,407a48.19,48.19,0,0,0-10.44-4.64s-6.25-27.32-9.51-35.7l-15-10.65s-32.4,13.73-42.62-6.55a22,22,0,0,1-1-2.34c-1.75-4.57-11.84-29-22.09-15.42h0a11.44,11.44,0,0,1-3.39-5.09h0s10.1-9.5,17.06,1.52l11.61,17.4s8.12,18,30.74,5.8a36.47,36.47,0,0,1,24.37-7s8.72,1.94,11.54-4.37c2.63.82,8.13,3.86-4,13.66C518.33,353.61,524.71,367.53,531.09,407Z",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M624,629.36h0c-11.52,5.28-25.25-.2-30.67-12.23L521.67,458.26c-5.42-12-.47-26.05,11-31.33h0c11.52-5.27,25.26.21,30.68,12.24L635,598C640.41,610.06,635.47,624.09,624,629.36Z",
    fill: "#EC1C24"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M638.26,614.86h0a22.91,22.91,0,0,1-27.82,16.78L486,600A23.15,23.15,0,0,1,469.4,572h0a22.89,22.89,0,0,1,27.81-16.78l124.42,31.6A23.14,23.14,0,0,1,638.26,614.86Z",
    fill: "#EC1C24"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.87 496.89 250.71 601.51 330.91 496.89 181.87 496.89",
    fill: "#fff",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M435.56,315.61c8.13-2.36,16.12,3.15,21.14,9.13a195,195,0,0,1,11.74,17.64c-4.42-5.48-8.25-11.4-12.61-16.9-5-5.81-12.21-11.22-20.27-9.87Z",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.06,320c4.77,8.18,12.39,14.21,20.39,19,1.17.69,2.36,1.32,3.52,2-9.87-3.6-20-11-23.91-21.05Z",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M468.44,387c-5.92,0-10.73-4.29-10.73-9.57s4.81-9.57,10.73-9.57,10.73,4.29,10.73,9.57S474.36,387,468.44,387Zm0-18.56c-5.6,0-10.15,4-10.15,9s4.55,9,10.15,9,10.15-4,10.15-9S474,368.4,468.44,368.4Z",
    fill: "#243E59"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M492.8,353h13.57a7.31,7.31,0,0,1,7.31,7.31v2.78a7.31,7.31,0,0,1-7.31,7.31H492.8a0,0,0,0,1,0,0V353A0,0,0,0,1,492.8,353Z",
    transform: "translate(-115.94 334.99) rotate(-33.24)",
    fill: "#f2c5be"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.43,
    cy: 361.57,
    r: 3.5,
    fill: "#f29596"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M453.66,371.3a124,124,0,0,1,.43,15.66l-.43-.43c2.21.07,4.42.2,6.64.43-2.35.25-4.7.38-7.06.44a123.64,123.64,0,0,1,.42-16.1Z",
    fill: "#332113"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M449.58,378.23l-.44-.37a7.42,7.42,0,0,1,9-1.66l-.26.52A6.73,6.73,0,0,0,449.58,378.23Z",
    fill: "#243E59"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M452,396.06a14.12,14.12,0,0,0,12.57.82,24.93,24.93,0,0,0,3.87-2.16c-.52.55-1.05,1.09-1.62,1.59a11.29,11.29,0,0,1-14.82-.25Z",
    fill: "#332113"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M432.69,367.82c.09-2.63,3.55-3.68,5.58-2.48-2.12.37-4.12.63-5.58,2.48Z",
    fill: "#332113"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.7cdf9703e9030b387eab863ce65264d4.svg";
export { ForwardRef as ReactComponent };